export const WA_NUMBER_DISPLAY = "+91 98217 71460";
export const WA_NUMBER = "919821771460";

export const waLink = (message) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;

export const CONTEXT_MESSAGES = {
  general:
    "Hi Somil, I found Grotech Web online and would like to discuss a website for my business.",
  new: "Hi Grotech Web! I'm interested in creating a new website for my business and would like to discuss the requirements.",
  redesign:
    "Hi Grotech Web! I have an existing website and would like to discuss redesigning and improving it.",
  seo: "Hi Grotech Web! I'm interested in improving my website's SEO and Google visibility.",
  b2b: "Hi Grotech Web! I'm looking for a website that can help generate more B2B enquiries for my business.",
  growth:
    "Hi Grotech Web! I'm interested in learning how the monthly website growth and SEO subscription works.",
  local:
    "Hi Grotech Web! I want to attract more customers from local Google searches in my city. Can we discuss?",
  landing:
    "Hi Grotech Web! I need a high-converting landing page for a campaign. Can we discuss?",
  portfolio:
    "Hi Grotech Web! I saw your portfolio and I'd like a similar website for my business.",
  blog: "Hi Grotech Web! I was reading your insights and I'd like a website that generates leads for my business.",
  reviews:
    "Hi Somil, I visited Grotech Web and would like to discuss a website for my business.",
  shopify:
    "Hi Somil! I have (or want) a Shopify store and would like to discuss getting more traffic and orders.",
  ai: "Hi Somil! I'm interested in AI chatbots / AI automation for my business. Can we discuss?",
  leave_review:
    "Hi Somil! I worked with Grotech Web and would like to share my experience as a review.",
};

export const leadMessage = ({ name, business, phone, city, requirement, details }) =>
  [
    "Hi Grotech Web! I submitted an enquiry through your website.",
    "",
    `Name: ${name}`,
    `Business: ${business}`,
    `Phone: ${phone}`,
    city ? `City: ${city}` : null,
    requirement ? `Requirement: ${requirement}` : null,
    details ? `Details: ${details}` : null,
  ]
    .filter(Boolean)
    .join("\n");

export const routeMessageKey = (pathname) => {
  if (pathname.includes("b2b-lead-generation")) return "b2b";
  if (pathname.includes("website-redesign")) return "redesign";
  if (pathname.includes("seo") || pathname.includes("monthly-seo-growth")) {
    if (pathname.includes("local")) return "local";
    if (pathname.includes("monthly")) return "growth";
    return "seo";
  }
  if (pathname.includes("landing-page")) return "landing";
  if (pathname.includes("website-developer-")) return "new";
  if (pathname.startsWith("/projects")) return "portfolio";
  if (pathname.startsWith("/blog")) return "blog";
  if (pathname.includes("business-website")) return "new";
  return "general";
};
